import { FC } from 'react';

import { withA11yVisuallyHidden } from '@telialt/common-a11y/src/withA11yVisuallyHidden';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { withParams } from '@telialt/utils/src/helpers';

import { PLAN_CARD_TEST_ID } from '../constants';
import { HeadingLevel, PlanCardModel } from '../model';
import { OldTitleText, TitleHeading } from '../PlanCard.styles';

type Props = { children: string; oldTitle?: string; tag?: HeadingLevel } & PlanCardModel.NegativeProp;

const OldTitleTextAccessible = withA11yVisuallyHidden(OldTitleText);

export const Title: FC<Props> = ({ children, oldTitle, isNegative }) => {
    const { t } = useTranslations();

    return (
        <TitleHeading $negative={isNegative} data-test={PLAN_CARD_TEST_ID.TITLE}>
            <div>{children}</div>
            {oldTitle && (
                <OldTitleTextAccessible
                    accessible={withParams(t['plans.data.old_data.aria_label'], { name: oldTitle })}
                    data-test={PLAN_CARD_TEST_ID.OLD_TITLE}
                >
                    {oldTitle}
                </OldTitleTextAccessible>
            )}
        </TitleHeading>
    );
};
